import store from '/@/store'
import { getRoot } from '/@/root'
import { ELocalStorageKey, EDeviceTypeName } from '/@/types'
import { getDeviceBySn } from '/@/api/manage'
import { message } from 'ant-design-vue'
import dockIcon from '/@/assets/icons/dock.png'
import rcIcon from '/@/assets/icons/rc.png'
import droneIcon from '/@/assets/icons/drone.svg'
import arrowIcon from '/@/assets/icons/arrow-up-circle.svg'

import { Point, LineString } from 'ol/geom'
import { Icon, Stroke, Style } from 'ol/style'
import Feature from 'ol/Feature'
import { fromLonLat, toLonLat } from 'ol/proj'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import { getVectorContext } from 'ol/render'

import * as Cesium from 'cesium'

export function deviceTsaUpdate () {
  const root = getRoot()
  const AMap = root.$aMap

  let oldPos: Cesium.Cartesian4 | null = null

  const icons = new Map([
    [EDeviceTypeName.Aircraft, droneIcon],
    [EDeviceTypeName.Gateway, rcIcon],
    [EDeviceTypeName.Dock, dockIcon]
  ])
  const colors = new Map([
    [EDeviceTypeName.Aircraft, '#FFFFFF'], // '#3669EBFF'],
    [EDeviceTypeName.Gateway, '#4F3300FF'],
    [EDeviceTypeName.Dock, '#FFFFFF']
  ])
  const markers = store.state.markerInfo.coverMap
  const paths = store.state.markerInfo.pathMap

  interface Marker {
    x: number;
    y: number;
    lng: number;
    lat: number;
    head: number;
    speed: number;
    elevation: number;
    height: number;
  }

  const markerPositions: { [sn: string]: Marker[] } = {}

  const markerCurrentPosition: {
    [sn: string]: {
      x: number,
      y: number,
      head: number,
      height: number,
    }
  } = {}

  let isMarkerMoving:boolean = false
  let markerLayer = null as any
  let routeLineLayer = null as any
  // let routePointLayer = null as any

  const droneModels: {
    [sn: string]: Cesium.Model
  } = {}

  const droneModelPromises: {
    [sn: string]: Promise<Cesium.Model> | null
  } = {}

  // const routeLayers: { [sn: string]: any } = {}
  const routeLayerLine: { [sn: string] : any} = {}
  // let trackLine = null as any

  // let trackLineCoordinates = null as any
  // let trackLineCoordinatesIndex:number = -1 // control the trackLineCoordinates array values
  // let trackLinePoints = null as any
  const default_speed = 1

  let ol3dIsEnabled:boolean = false
  // let lerpIntervalId: number | undefined

  function lerp (start: number, end: number, t: number): number {
    let k = t / 180
    if (k > 1)k = 1
    // if (Math.abs(end - start) < 5) k = 1 // not really smooth
    // 0 => 1
    // 3 => 1/60
    return start + (end - start) * k // k = 1/60 to 1
    // return start + (end - start) / (t * 20)
  }

  function moveMarker (event?:any) {
    // const scaleHeight = 90 => 200 => 1.2
    //                     0 => 90 => 1
    if (isMarkerMoving) return

    // const mapZoom = root.$map.getView().getZoom()
    // const iconScale = (0.045 * mapZoom - 0.3)

    isMarkerMoving = true
    for (const sn in markers) {
      const markerPositionsLength = markerPositions[sn].length
      const targetPosition = markerPositions[sn][markerPositionsLength - 1]
      if (targetPosition) {
        // const target = markerTargetPosition[sn]
        // const marker = markers[sn]

        // if (target && marker) {
        //   const geometry = marker.getGeometry()
        //   const currentCoord = geometry.getCoordinates()
        //   const { x: targetX, y: targetY, head: targetHead } = target

        //   // Calculate smooth next position using linear interpolation
        //   const newX = lerp(currentCoord[0], targetX, speed)
        //   const newY = lerp(currentCoord[1], targetY, speed)

        //   // Clone and move geometry for rendering
        //   const geom = geometry.clone()
        //   geom.setCoordinates([newX, newY])

        //   // Clone and rotate style
        //   const style = marker.getStyle().clone()
        //   style.getImage().setRotation(targetHead)

        //   const vectorContext = getVectorContext(event)
        //   vectorContext.setStyle(style)
        //   vectorContext.drawGeometry(geom)

        //   // Optional: Update internal geometry if you want real position to change over time
        //   // geometry.setCoordinates([newX, newY])
        const { x, y, lng, lat, head, speed, elevation, height } = targetPosition
        // const speed_x = speed * Math.cos(head)
        // const speed_y = speed * Math.sin(head)
        // Clone current geometry
        const geom = markers[sn].getGeometry()

        const newX = lerp(markerCurrentPosition[sn].x, x, speed)
        const newY = lerp(markerCurrentPosition[sn].y, y, speed)
        const newHead = lerp(markerCurrentPosition[sn].head, head, 1)
        const newHeight = lerp(markerCurrentPosition[sn].height, height, speed)

        geom.setCoordinates([newX, newY, newHeight]) // ✅ setCoordinates takes [x, y] as array

        // Clone and update style with new rotation
        const style = markers[sn].getStyle().clone()
        style.getImage().setRotation(head)

        // set icon scale
        // let elevationScale = (markerTargetPosition[sn].elevation + 20) / 100 * 15
        // if (elevationScale < 9) elevationScale = 9
        // style.getImage().setScale(elevationScale / 10)

        const vectorContext = getVectorContext(event)
        vectorContext.setStyle(style)
        vectorContext.drawGeometry(geom)
        markerCurrentPosition[sn] = { x: newX, y: newY, head: newHead, height: newHeight }
        markers[sn].setStyle(style)
      }
    }
    isMarkerMoving = false
    // markerLayer.on('postrender', moveMarker)
    // root.$map.render()
  }

  // start the interval
  // function startInterval () {
  //   if (!lerpIntervalId) {
  //     lerpIntervalId = window.setInterval(() => {
  //       moveMarker()
  //     }, 500)
  //   }
  // }

  // // stop it from outside
  // function stopInterval () {
  //   if (lerpIntervalId) {
  //     clearInterval(lerpIntervalId)
  //     lerpIntervalId = undefined
  //   }
  // }

  // function initTrackLineFeature () {
  //   if (markerVectorSource) {
  //     if (trackLineCoordinates.length === 0) {
  //       trackLine = new Feature({
  //         geometry: new LineString([]) // empty initially
  //       })
  //     } else {
  //       trackLine = new Feature({
  //         geometry: new LineString(trackLineCoordinates)
  //       })
  //     }
  //     trackLine.setStyle(new Style({
  //       stroke: new Stroke({
  //         color: '#ffcc33ff',
  //         width: 3,
  //       }),
  //     }))
  //     markerVectorSource.addFeature(trackLine)
  //   }
  // }

  // function getTrackLineInstance () {
  //   if (!trackLine) {
  //     initTrackLineFeature()
  //     // trackLine = new AMap.Polyline({
  //     //   map: root.$map,
  //     //   strokeColor: '#939393' // 线颜色
  //     // })
  //   }

  //   return trackLine
  // }

  function updateRouteLayerline (enable3d: boolean, sn: string) {
    // const trackLine = trackLines[sn]

    // trackLineCoordinatesIndex++
    // if (trackLineCoordinatesIndex < 2) {
    //   return
    // }

    // trackLineCoordinates.push(coordinate)
    // getTrackLineInstance().getGeometry().setCoordinates(trackLineCoordinates)
    const posIdx = markerPositions[sn].length - 1

    if (posIdx < 2) return

    if (!routeLayerLine[sn]) {
      const line = new LineString([
        [markerPositions[sn][posIdx].x, markerPositions[sn][posIdx].y, markerPositions[sn][posIdx].height],
        [markerPositions[sn][posIdx - 1].x, markerPositions[sn][posIdx - 1].y, markerPositions[sn][posIdx - 1].height]
      ])

      routeLayerLine[sn] = new Feature({
        geometry: line
      })

      routeLayerLine[sn].setStyle(new Style({
        stroke: new Stroke({
          color: '#ffcc33ff',
          width: 3,
        }),
      }))
      routeLineLayer.getSource().addFeature(routeLayerLine[sn])
      // if (enable3d) return
    } else {
      const geometry = routeLayerLine[sn].getGeometry()
      geometry.appendCoordinate([markerPositions[sn][posIdx].x, markerPositions[sn][posIdx].y, markerPositions[sn][posIdx].height])
      routeLayerLine[sn].changed()
    }

    // if (!enable3d) {
    //   const point = new Feature({
    //     geometry: new Point([markerPositions[sn][posIdx].x, markerPositions[sn][posIdx].y, markerPositions[sn][posIdx].height])
    //   })

    //   point.setStyle(
    //     new Style({
    //       image: new Icon({
    //         src: arrowIcon,
    //         anchor: [0.5, 0.5],
    //         scale: 0.25,
    //         rotateWithView: true,
    //         rotation: markerPositions[sn][posIdx].head,
    //       })
    //     })
    //   )

    //   routePointLayer.getSource().addFeature(point)
    // }
  }

  // function initIcon (type: number) {
  //   // window.console.log('use-g-map-tsa initIcon:', icons.get(type))
  //   return new AMap.Icon({
  //     image: icons.get(type),
  //     imageSize: new AMap.Size(40, 40),
  //     size: new AMap.Size(40, 40)
  //   })
  // }

  function clearRouteLayerLine (sn: string) {
    delete routeLayerLine[sn]
    const posIdx = markerPositions[sn].length - 1
    const lastMarker = markerPositions[sn][posIdx]
    markerPositions[sn] = [lastMarker]
    markerCurrentPosition[sn] = { x: lastMarker.x, y: lastMarker.y, head: lastMarker.head, height: lastMarker.height }
  }

  function cleanRouteLayer () {
    routeLineLayer.getSource().clear()
    // routePointLayer.getSource().clear()
    for (const sn in markers) {
      clearRouteLayerLine(sn)
    }
  }

  function initMarker (
    type: number, name: string, sn: string, lng?: number, lat?: number, head?: number,
    elevation?: number, height?: number) {
    if (!root.$map) return

    const mapZoom = root.$map?.getView().getZoom()
    const iconScale = (0.045 * mapZoom - 0.3)
    // window.console.log('use-g-map-tsa mapZoom:', mapZoom)

    // window.console.log('use-g-map-tsa initmarker')
    if (markers[sn]) {
      if (lng !== undefined && lat !== undefined) {
        const coordinate = fromLonLat([lng, lat])

        markerPositions[sn].push({ x: coordinate[0], y: coordinate[1], lng: lng, lat: lat, head: head || 0, speed: default_speed, elevation: elevation || 0, height: height || 0 })
        markerCurrentPosition[sn] = { x: coordinate[0], y: coordinate[1], head: head || 0, height: height || 0 }

        markers[sn].getGeometry().setCoordinates(coordinate)
        markers[sn].getStyle().getImage().setRotation(head || 0)
        markers[sn].changed()
      }
    } else {
      // if (root.$aMap === undefined) {
      //   return
      // }

      // window.console.log('use-g-map-tsa initmarker set feature')
      // Create a point feature with icon style
      // [128.31055618348088, 37.2565747455925]
      const lngIn = lng || 128.31055618348088
      const latIn = lat || 37.2565747455925
      const coordinate = fromLonLat([lngIn, latIn])

      if (sn.length > 0) {
        markers[sn] = new Feature({
          geometry: new Point(coordinate), // Initial position [lon, lat]
          name: sn,
        })

        markers[sn].setStyle(new Style({
          image: new Icon({
            anchor: [0.5, 0.5],
            src: icons.get(type),
            scale: iconScale,
            rotation: head,
            rotateWithView: true,
          })
        }))

        markerPositions[sn] = [{ x: coordinate[0], y: coordinate[1], lng: lngIn, lat: latIn, head: head || 0, speed: default_speed, elevation: elevation || 0, height: height || 0 }]
        markerCurrentPosition[sn] = { x: coordinate[0], y: coordinate[1], head: head || 0, height: height || 0 }

        if (!routeLineLayer) {
          routeLineLayer = new VectorLayer({
            source: new VectorSource()
          })

          root.$map.addLayer(routeLineLayer)
        }

        // if (!routePointLayer) {
        //   routePointLayer = new VectorLayer({
        //     source: new VectorSource()
        //   })
        //   root.$map.addLayer(routePointLayer)
        // }

        if (!markerLayer) {
          markerLayer = new VectorLayer({
            source: new VectorSource({
              features: [markers[sn]]
            })
          })

          root.$map.addLayer(markerLayer)
        } else {
          markerLayer.getSource().addFeature(markers[sn])
        }

        root.$map.render()
      }

      // if (type === EDeviceTypeName.Aircraft) {
      //   // --- 4️⃣ Add click event listener ---
      //   root.$map.on('click', function (evt: any) {
      //     // Check if user clicked on a feature
      //     root.$map.forEachFeatureAtPixel(evt.pixel, function (feature: Feature, layer: VectorLayer) {
      //       const sn = feature.get('sn')
      //       alert('You clicked on: ' + sn)
      //     })
      //   })
      // }

      // AMap = root.$aMap
      // markers[sn] = new AMap.Marker({
      //   position: new AMap.LngLat(lng || 113.943225499, lat || 22.577673716),
      //   icon: initIcon(type),
      //   title: name,
      //   anchor: 'top-center',
      //   offset: [0, -20],
      // })
      // root.$map.add(markers[sn])
      // markers[sn].on('moving', function (e: any) {
      //   let path = paths[sn]
      //   if (!path) {
      //     paths[sn] = e.passedPath
      //     return
      //   }
      //   path.push(e.passedPath[0])
      //   path.push(e.passedPath[1])
      // })
    }
  }

  function removeMarker (sn: string) {
    markerLayer.getSource().removeFeature(markers[sn])
    routeLineLayer.getSource().removeFeature(routeLayerLine[sn])
    // routePointLayer.getSource().clear()
    delete routeLayerLine[sn]
    delete markers[sn]
    delete markerPositions[sn]
    delete markerCurrentPosition[sn]
    delete paths[sn]
    // stopInterval()
    // root.$map.remove(markers[sn])
    // getTrackLineInstance().setPath([])
  }

  function genModelMatrix (lat:number, lng:number, height:number, heading: number) {
    // Position a model with modelMatrix and display it with a minimum size of 128 pixels
    const positionSet = Cesium.Cartesian3.fromDegrees(
      lng,
      lat,
      height
    )

    const headingPositionRoll = new Cesium.HeadingPitchRoll(heading)
    const fixedFrameTransform = Cesium.Transforms.localFrameToFixedFrameGenerator(
      'north',
      'west'
    )

    const modelMatrix =
        Cesium.Transforms.headingPitchRollToFixedFrame(
          positionSet,
          headingPositionRoll,
          Cesium.Ellipsoid.WGS84,
          fixedFrameTransform
        )
    return modelMatrix
  }

  async function addDroneModel (ol3d: any, lat:number, lng:number, height:number, heading: number) {
    const scene = ol3d.getCesiumScene()

    const model = await Cesium.Model.fromGltfAsync({
      url: '/3d/DJI-Mavic_3.glb',
      modelMatrix: genModelMatrix(lat, lng, height, heading),
      scale: 0.4,
      minimumPixelSize: 40,
      maximumScale: 200
    })
    scene.primitives.add(model)

    // === START ROTOR ANIMATION AFTER MODEL LOADS ===
    // === Manual Rotor Animation ===
    // model.readyPromise.then((loadedModel: Cesium.Model) => {
    //   console.log('✅ Drone model loaded, starting rotor animation')

    //   // Get all propeller nodes
    //   const propellerNodes = [
    //     loadedModel.getNode('桨叶1'),
    //     loadedModel.getNode('桨叶2'),
    //     loadedModel.getNode('桨叶3'),
    //     loadedModel.getNode('桨叶4'),
    //   ].filter(Boolean) // remove null if some don't exist

    //   if (propellerNodes.length === 0) {
    //     console.warn('⚠️ Propeller nodes not found. Check exact node names in glTF viewer.')
    //   }

    //   // let rotationAngle = 0

    //   // // Use Cesium's post-update to rotate every frame
    //   // const removeCallback = scene.postUpdate.addEventListener(() => {
    //   //   rotationAngle += 0.25 // adjust speed (radians per frame)

    //   //   propellerNodes.forEach((node: any, index: number) => {
    //   //     if (!node) return

    //   //     // Rotate around local Z-axis (most common for propellers)
    //   //     const rotation = Cesium.Matrix3.fromRotationZ(rotationAngle + index * (Math.PI / 2)) // slight phase difference

    //   //     node.matrix = Cesium.Matrix4.fromRotationTranslation(
    //   //       rotation,
    //   //       Cesium.Matrix4.getTranslation(node.matrix, new Cesium.Cartesian3()), // keep original position
    //   //       node.matrix
    //   //     )
    //   //   })
    //   // })

    //   // Optional: store remover so you can stop animation later
    //   // (model as any)._rotorRemover = removeCallback
    // })

    return model
  }

  async function updateDroneModel (sn: string, ol3d: any, lat:number, lng:number, h:number, hd: number) {
    const scene = ol3d.getCesiumScene()
    const droneModel = droneModels[sn]
    const droneModelPromise = droneModelPromises[sn]

    if (droneModel && scene.primitives.contains(droneModel)) {
      droneModel.modelMatrix = genModelMatrix(lat, lng, h, hd)
      return
    }

    if (!droneModelPromise) {
      droneModelPromises[sn] = addDroneModel(ol3d, lat, lng, h, hd)
        .then((model) => {
          droneModels[sn] = model
          return model
        })
        .finally(() => {
          droneModelPromises[sn] = null
        })
    }

    await droneModelPromises[sn]
  }

  function addMarker (sn: string, lng?: number, lat?: number, head?: number, elevation?: number, height?: number) {
    getDeviceBySn(localStorage.getItem(ELocalStorageKey.WorkspaceId)!, sn)
      .then(data => {
        if (data.code !== 0) {
          message.error(data.message)
          return
        }
        initMarker(data.data.domain, data.data.nickname, sn, lng, lat, head, elevation, height)
      })
  }

  function moveTo (
    enable3d: boolean,
    sn: string,
    lng: number, lat: number,
    head?: number,
    horizontal_speed?:number, elevation?:number, height?: number) {
    // console.log('moveTo elevation: ' + elevation + ' height: ' + height)
    const coordinate = fromLonLat([lng, lat])
    const newPos = Cesium.Cartesian4.fromArray([coordinate[0], coordinate[1], height || 0, head || 0])
    if (oldPos) {
      if (oldPos.equalsEpsilon(newPos, 0.0, 0.1)) { // e.g. unit m tolerance
        // console.log('same position in tolerance of 1 cm, returning')
        return
      }
    }
    oldPos = newPos

    if (!markerPositions[sn]) {
      markerPositions[sn] = [{ x: coordinate[0], y: coordinate[1], lng: lng, lat: lat, head: head || 0, speed: default_speed, elevation: elevation || 0, height: height || 0 }]
    } else {
      markerPositions[sn].push({ x: coordinate[0], y: coordinate[1], head: head || 0, lng: lng, lat: lat, speed: horizontal_speed || default_speed, elevation: elevation || 0, height: height || 0 })
    }

    if (enable3d) {
      updateDroneModel(sn, root.$ol3d, lat, lng, height || 0, 180 - (head || 0))
    }

    updateRouteLayerline(enable3d, sn)

    if (ol3dIsEnabled !== enable3d) {
      // if (enable3d === true) {
      //   routePointLayer.getSource().clear()
      // }
      // routePointLayer.setVisible(!enable3d)
      markerLayer.setVisible(!enable3d)
      ol3dIsEnabled = enable3d
    }

    if (!enable3d) {
      const marker = markers[sn]
      if (!marker) {
        addMarker(sn, lng, lat, head, elevation, height)
      }
      // markerLayer.setVisible(!enable3d)
      markerLayer.on('postrender', moveMarker)
    }
    // addTrackLinePoint(sn, coordinate, head || 0)
    // startInterval()
    // root.$map.getView().setCenter(coordinate)
  }

  return {
    marker: markers,
    initMarker,
    removeMarker,
    cleanRouteLayer,
    moveTo
  }
}
